module.exports = __webpack_public_path__ + "static/media/icon-payment-tips.fc0d1b49.svg";